import { render, staticRenderFns } from "./badgeStatusApproval.vue?vue&type=template&id=464f5839&scoped=true&"
import script from "./badgeStatusApproval.vue?vue&type=script&lang=js&"
export * from "./badgeStatusApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f5839",
  null
  
)

export default component.exports